<template>
<div class="scaleline-10-wrapper">
  <div class="scaleline-10 scale-names flex gap-3">
    <div v-for="item in intervals" :key="item.id"
         class="scale-name "
         :style="{
                  color: item.id === lineData.matched_interval ? mainColor : '',
                  'font-weight': item.id === lineData.matched_interval ? 600 : '',
              }"
    >
      {{ item.subtitle }}
    </div>
  </div>
  <div class="scaleline-10 scaleline-10-blocks">
    <div v-for="ind in 10" :key="ind" class="item-block" :style="{background: getItemColor(ind-1, false), borderColor: mainColor}">
      <div v-if="ind-1 === valueFloor" class="item-block-fill" :style="{width: fillWidth, background: getItemColor(ind-1, true) }" />
      <span v-if="ind-1 === valueFloor || ( valueFloor==10 && ind===10)" class="item-block-value">
        {{ valueShow }}
      </span>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import { hexToRgb, hslToRgb, rgbToHsl } from '@/common/util';

export default {
  props: {
      lineData: {
          type: Object,
          default() {
              return {
                  interval_aware_value: 50,
                  value: 50,
                  matched_interval: 1,
                  block: {
                      normalized_to: 100,
                  },
                  intervals: [
                      { id: 1, name: "Редкое?", color: '#E53E3E' },
                      { id: 2, name: "Оптимальное?", color: '#6FCF97' },
                      { id: 3, name: "Частое? ", color: '#E53E3E' },
                  ],
                  baseColor: [229, 62, 62], // rgb
              }
          }
      }
  },
  components: {
  },
  data() {
      return {
        // rgb(229, 62, 62)
      };
  },
  computed: {
    mainColor() {
        const interval = this.intervals.find(el => el.id === this.lineData.matched_interval);
        return interval ? interval.color : '#39A9DC'
    },
    lightColor() {
      return this.mainColor + '30'
    },
    rgbMainColor(){
      return hexToRgb(this.mainColor)
    },
    isGradiendToLast() {
        return this.intervals.findIndex(el => el.id === this.lineData.matched_interval) === this.intervals.length-1;
    },
    isGradiendToFirst() {
        return this.intervals.findIndex(el => el.id === this.lineData.matched_interval) === 0;
    },
    valueNorm() {
      return Math.round(this.lineData.interval_aware_value)
    },
    valueShow() {
      return Math.round(this.lineData.interval_aware_value)
    },
    fillWidth() {
      // return '100%'
      const v = (this.value10 - this.valueFloor) * 100
      return (v<10 ? 10: v) + '%'
    },
    intervals() {
      return this.lineData.intervals.sort((a, b) => a.value_from - b.value_from )
    },
    value10() {
      return this.valueNorm / (this.lineData.block ? this.lineData.block.normalized_to : 1) * 10
    },
    valueFloor() {
      return Math.floor(this.value10)
    },
  },
  methods: {
    getItemColor(ind, isForeground) {
      if (this.isGradiendToLast) {
        return ind < this.valueFloor || isForeground ? this.getGradientColorByIndex(ind, true) : this.lightColor
      } else if (this.isGradiendToFirst) {
        return ind < this.valueFloor || isForeground ? this.getGradientColorByIndex(ind, false) : this.lightColor
      } else {
        return ind < this.valueFloor || isForeground ? this.getGradientColorByIndex(ind, true) : this.lightColor
      }
    },

    getGradientColorByIndex(index, reverse) {
      // Базовый цвет: rgb(229, 62, 62)
      const baseColor = this.rgbMainColor ? this.rgbMainColor : [229, 62, 62];
      const total = this.valueFloor

      const [h, s, baseL] = rgbToHsl(...baseColor);
      const maxDelta = 20; // максимальное снижение яркости (в процентах)
      const step = maxDelta / (total+1);

      // Яркость начала и конца для квадратика с индексом index
      const startL = reverse ? Math.max(0, baseL + (total-index) * step) : Math.max(0, baseL + index * step);
      const endL = reverse ? Math.max(0, baseL + (total-index + 1) * step) : Math.max(0, baseL + (index + 1) * step);

      const startColor = hslToRgb(h, s, startL);
      const endColor = hslToRgb(h, s, endL);

      return `linear-gradient(to right, ${startColor}, ${endColor})`;
    },

  },
};
</script>


<style scoped lang="scss">
@import "src/assets/styles/variables";

.scaleline-10-wrapper {
  width: fit-content;
}

.scaleline-10 {
  display: flex;
  width: 100%;
}

.scaleline-10-blocks {
  // width: 320px;
  // max-width: 320px;
  // justify-content: space-between;
  // flex-wrap: no-wrap;
}

.scaleline-10 .item-block {
  width: 31px;
  height: 32px;
  border: 1px solid #fff;
  border-radius: 5px;
  flex: 31px 0 0;
  color: #444;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1px;
}

.item-block-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
}


.scaleline-10.scale-names {
  font-size: 11px;
  height: 36px;
  padding-bottom: 6px;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 15px;
  color: #ccc;
}

.item-block-value {
  z-index: 10;
}

@media screen and (max-width: 800px) {
  .scaleline-10 .item-block {
      width: 16px;
      flex: 16px 0 0;
      height: 16px;
      border-radius: 3px;
  }
  .scaleline-10 .item-block-value {
      font-size: 10px;
  }
  .scaleline-10.scale-names {
      font-size: 7.5px;
      // margin-bottom: 3px;
  }
}

</style>
